/**
 * Who may manage a campaign — create, complete and delete it (VOX-317). Mirrors
 * Voice's `CAMPAIGN_MANAGE_ROLES` (`chatbotAccess.service.ts`); pausing,
 * resuming, starting and editing are open to anyone with agent access.
 *
 * Dependency-free on purpose: the router imports it eagerly to gate
 * `campaigns/new`, and anything this module imported would land in the main
 * chunk with it.
 *
 * ⚠️ Presentation, never the boundary: Voice re-checks every write.
 */

export const CAMPAIGN_MANAGE_ROLES = [
  'superuser',
  'superadmin',
  'implementador',
  'admin',
  'supervisor',
] as const;

export function canManageCampaigns(role: string | null | undefined): boolean {
  return (CAMPAIGN_MANAGE_ROLES as readonly string[]).includes(role ?? '');
}
